/* Cool-jams quick-view gallery colour filter, 2026-09-02.

   On PDPs the Variant Image Wizard app trims the gallery to the picked colour, but its
   script only runs on product pages, so quick-view modals showed every photo. This file
   brings the modal galleries in line: it reads the SAME per-variant media lists the app
   prints into each PDP (window.__productWizRioVariantImages), then filters the modal's
   flickity cells and thumbnails to the current variant's list.

   Mechanics that matter (learned the hard way):
   - Cells hidden with display:none STAY in flickity's rotation as blank zero-width
     frames, so filtering is done by flickity remove/append, always re-appending from a
     master snapshot in original order.
   - Thumb clicks survive removal because the theme's goToSlide() addresses cells by
     data-media-id, not index. Only the active-thumb highlight is index-based, so it is
     corrected here by media id after each select.
   - The rio JSON is extracted from the (browser-cached) PDP HTML with a string-aware
     brace scan; JSON.parse on a regex slice fails because more script follows the object.
   - Product.onSlideChange looks slides up by data-index and crashes on a stale
     currentSlideIndex after cells change, so kept slides are reindexed 0..n-1 and the
     Product instance (found via theme.sections.instances by container) gets its
     currentSlideIndex resynced to 0 before the post-filter select.
   Products without wizard data, and everything outside a quick-shop modal, are untouched. */
(function () {
  if (!window.fetch) return;

  var rioCache = {};
  var states = typeof WeakMap === 'function' ? new WeakMap() : null;
  if (!states) return;

  function extractRio(text) {
    var i = text.indexOf('__productWizRioVariantImages');
    if (i === -1) return null;
    var start = text.indexOf('{', i);
    if (start === -1) return null;
    var depth = 0, end = -1, inStr = false, esc = false;
    for (var p = start; p < text.length; p++) {
      var c = text[p];
      if (esc) { esc = false; continue; }
      if (c === '\\') { esc = true; continue; }
      if (c === '"') { inStr = !inStr; continue; }
      if (inStr) continue;
      if (c === '{') depth++;
      else if (c === '}') { depth--; if (depth === 0) { end = p + 1; break; } }
    }
    if (end === -1) return null;
    try { return JSON.parse(text.slice(start, end)); } catch (e) { return null; }
  }

  function getMap(handle) {
    if (rioCache[handle] !== undefined) return Promise.resolve(rioCache[handle]);
    return fetch('/products/' + handle)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var rio = extractRio(text);
        var map = null;
        if (rio && rio.enabled && rio.mapping && rio.mapping.length) {
          map = {};
          rio.mapping.forEach(function (m) {
            map[String(m.id)] = m.media.map(String);
          });
        }
        rioCache[handle] = map;
        return map;
      })
      .catch(function () { rioCache[handle] = null; return null; });
  }

  function getState(modal) {
    var st = states.get(modal);
    if (st) return st;
    var sliderEl = modal.querySelector('.product-slideshow.flickity-enabled');
    if (!sliderEl || !window.Flickity || !Flickity.data(sliderEl)) return null;
    st = {
      sliderEl: sliderEl,
      master: [].slice.call(modal.querySelectorAll('.product-main-slide')),
      thumbs: [].slice.call(modal.querySelectorAll('.product__thumb-item')),
      links: [].slice.call(modal.querySelectorAll('.product__thumb-item a, .product__thumb-item .product__thumb'))
    };
    states.set(modal, st);
    return st;
  }

  function productInstance(sectionEl) {
    var list = (window.theme && theme.sections && theme.sections.instances) || [];
    for (var i = list.length - 1; i >= 0; i--) {
      if (list[i].container === sectionEl && list[i].type === 'product') return list[i];
    }
    return null;
  }

  function markActiveThumb(st, mediaId) {
    st.thumbs.forEach(function (t, i) {
      var link = t.querySelector('a, .product__thumb');
      if (!link) return;
      link.classList.toggle('is-active', String(st.master[i] && st.master[i].dataset.mediaId) === String(mediaId));
    });
  }

  function applyFilter(modal, variantId, featuredMediaId) {
    var st = getState(modal);
    if (!st) return;
    var section = modal.querySelector('.product-section[data-product-handle]');
    if (!section) return;
    getMap(section.dataset.productHandle).then(function (map) {
      if (!map) return;
      var allowed = map[String(variantId)];
      var keepIds = allowed && allowed.length ? allowed : st.master.map(function (s) { return s.dataset.mediaId; });
      var keepSet = {};
      keepIds.forEach(function (id) { keepSet[String(id)] = true; });

      var flk = Flickity.data(st.sliderEl);
      if (!flk) return;
      var keepEls = st.master.filter(function (s) { return keepSet[String(s.dataset.mediaId)]; });
      if (!keepEls.length) return;

      // The theme's onSlideChange resolves slides by data-index on every select event,
      // including the ones flickity emits mid-surgery, and throws on a miss. Point every
      // index at 0 for the duration so any lookup lands on a real node, then assign the
      // final 0..n-1 sequence once the cell set is settled.
      var inst = productInstance(section);
      try {
        st.master.forEach(function (s) { s.setAttribute('data-index', '0'); });
        if (inst && inst.settings) inst.settings.currentSlideIndex = 0;
        flk.remove(flk.getCellElements());
        flk.append(keepEls);
        flk.resize();
      } catch (e) { /* never let gallery surgery break the modal */ }

      keepEls.forEach(function (s, i) { s.setAttribute('data-index', i); });
      if (inst && inst.settings) inst.settings.currentSlideIndex = 0;

      var target = featuredMediaId && keepSet[String(featuredMediaId)]
        ? String(featuredMediaId)
        : String(keepEls[0].dataset.mediaId);
      var cells = flk.cells || [];
      try {
        for (var c = 0; c < cells.length; c++) {
          if (String(cells[c].element.dataset.mediaId) === target) {
            flk.selectCell(cells[c].element, false, true);
            break;
          }
        }
      } catch (e) { /* selection is best-effort */ }

      st.thumbs.forEach(function (t, i) {
        var slide = st.master[i];
        t.classList.toggle('hide', !(slide && keepSet[String(slide.dataset.mediaId)]));
      });
      markActiveThumb(st, target);
    });
  }

  function currentVariantId(modal) {
    var sel = modal.querySelector('[data-product-select]');
    return sel ? sel.value : null;
  }

  document.addEventListener('quickview:loaded', function (evt) {
    setTimeout(function () {
      var modal = document.querySelector('.modal--quick-shop.modal--is-active');
      if (!modal) return;
      var vid = currentVariantId(modal);
      if (vid) applyFilter(modal, vid, null);
    }, 80);
  });

  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    var modal = document.querySelector('.modal--quick-shop.modal--is-active');
    if (!modal) return;
    var featured = variant.featured_media ? variant.featured_media.id : null;
    setTimeout(function () { applyFilter(modal, variant.id, featured); }, 0);
  });
})();
